import { render, staticRenderFns } from "./play.vue?vue&type=template&id=901a6f28&scoped=true&"
import script from "./play.vue?vue&type=script&lang=ts&"
export * from "./play.vue?vue&type=script&lang=ts&"
import style0 from "./play.vue?vue&type=style&index=0&id=901a6f28&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901a6f28",
  null
  
)

export default component.exports